// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img[data-v-0c1f937e]{width:44px;height:44px;cursor:pointer}.img img[data-v-0c1f937e]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
